import React from 'react';
import { CheckCircle } from 'lucide-react';

export default function SuccessToast({ message, onClose, duration = 3000 }) {
  React.useEffect(() => {
    if (message) {
      const timer = setTimeout(() => onClose(), duration);
      return () => clearTimeout(timer);
    }
  }, [message, onClose, duration]);

  if (!message) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 300,
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '16px 24px',
      background: '#F0FDF4',
      border: '1px solid #BBF7D0',
      borderRadius: 12,
      boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
    }}>
      <CheckCircle size={20} color="#16A34A" />
      <span style={{ fontSize: 14, fontWeight: 600, color: '#16A34A' }}>{message}</span>
    </div>
  );
}
